<template>
  <div class="user-info-item">
    <div class="user-info-item-icon">
      {{ emoji }}
    </div>

    <div class="user-info-item-content">
      <div class="user-info-item-title">{{ title }}</div>
      <span class="user-info-item-link">{{ linkText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoItem',

  props: {
    emoji: {
      type: String,
      default: ''
    },

    title: {
      type: [String, Number],
      default: ''
    },

    linkText: {
      type: [String, Number],
      default: ''
    }
  }
};
</script>

<style lang="less">
.user-info-item {
  display: flex;
  align-items: center;

  &:not(:last-of-type) {
    margin-right: 25px;
  }
}

.user-info-item-icon {
  margin-right: 10px;
  font-size: 30px;
}

.user-info-item-title {
  font-size: 16px;
  color: #252525;
}

.user-info-item-link {
  line-height: 1 !important;
  font-size: 10px;
  color: #252525;
}

.user-info-item-content {
  display: flex;
  flex-direction: column;
}
</style>
